<template>
    <div class="p-4 text-sm">
        <h2 class="text-gray mb-6">Очистить расписание на месяц</h2>
       <MonthSwitcher class="mb-5" @date="onDate" />
       <dropdown v-model="employment" :options="employments" class="mb-4">
            {{ scheduleStore.cutStr(employment.name, 23) }}
        </dropdown>
       <div class="flex justify-end">
        <btn @click="clean" :disabled="isDisabled" :class="{'opacity-50': isDisabled}">Очистить</btn>
       </div>
    </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs'
import { Ref, ref, computed } from 'vue'
import utc from "dayjs/plugin/utc"
import MonthSwitcher from './MonthSwitcher.vue'
import { useScheduleStore } from '@/stores/scheduleStore'
import { useAuthStore } from '@/stores/authStore'
import { useToast } from 'vue-toast-notification'

const toast = useToast({ position: 'top' })

const scheduleStore = useScheduleStore()
const authStore = useAuthStore()

dayjs.extend(utc)
const emit = defineEmits(['close'])

const isDisabled = ref(true)
const start = ref()
const end = ref()
const employments = computed(() => {
    return [{id: null, name: 'Все' }, ...scheduleStore.schedules.filter(sch => !sch.is_vacancy).map(schedule => {
    const name = schedule.user.last_name + ' ' + schedule.user.first_name
    return {id: schedule.id, name}
})]
})
const employment = ref(employments.value[0]) 

const onDate = (date: Ref) => {
    start.value = date.value.startOf('month').format('YYYY-MM-DD')
    end.value = date.value.endOf('month').format('YYYY-MM-DD')
    isDisabled.value = dayjs().isAfter(date.value.startOf('month'))
}

const clean = async () => {
    emit('close')
    if(authStore.permissions?.can_create_schedule) {
        const data = {
        date_from: start.value,
        date_to: end.value,
        department_id: scheduleStore.currentDepartment?.id,
        employment_id: employment.value.id
    }
    await scheduleStore.scheduleCleanup(data)
    } else {
        toast.success('У вас нет прав на данное действие')
    }
}
</script>
